import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

class ApiService {
  constructor(endpoint, objectName) {
    this.endpoint = endpoint
    this.objectName = objectName
  }

  getItems(limit = 100, page = 1) {
    let queryUrl = `${API.URL + this.endpoint}?pageSize=${limit}&page=${page}`

    return ApiHelper.fetch(queryUrl)
  }

  getItem(id) {
    return ApiHelper.fetch(`${API.URL + this.endpoint}/${id}`)
  }

  addItem(item) {
    return ApiHelper.fetch(`${API.URL + this.endpoint}`, {
      method: 'POST',
      body: JSON.stringify({
        [this.objectName]: item
      })
    })
  }

  updateItem(item) {
    if (typeof item._id === 'undefined') {
      return this.addItem(item)
    }

    return ApiHelper.fetch(`${API.URL + this.endpoint}/${item['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        [this.objectName]: item
      })
    })
  }

  deleteItem(id) {
    return ApiHelper.fetch(`${API.URL + this.endpoint}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default ApiService
